import React from 'react';
import HowItWorks from '../UI/HowItsWorks';

const HowItWorksMEP = () => {


    const steps = [
        {
            number: 1,
            title: "Consult with Engineer",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FMEP%2FHOW_IT_WORKS_icon%2FConsultation_with_Engineer.png?alt=media&token=0d8910c6-971b-4de2-a2f3-825c8757f3e7",
            description: "Initial discussion about your project requirements and scope"
        },
        {
            number: 2,
            title: "Get Quote & Review Our Work",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FMEP%2FHOW_IT_WORKS_icon%2FGet_Quote_and_Review_Our_Work.png?alt=media&token=675fe583-b3fb-4877-966f-0d8e8feb0e6a",
            description: "Detailed cost estimation and portfolio presentation"
        },
        {
            number: 3,
            title: "Book Your Slot",
            icon:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FMEP%2FHOW_IT_WORKS_icon%2FBook_Your_Slot.png?alt=media&token=a8a5e623-6eaa-4023-a9c3-f6eb2ea8e13d",
            description: "Schedule your project timeline"
        },
        {
            number: 4,
            title: "MEP Drafting & Coordination",
            icon:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FMEP%2FHOW_IT_WORKS_icon%2FMEP_Drafting_and_Coordination.png?alt=media&token=3f9eb150-f1bc-4ee9-bf36-fbe8a45a33b0",
            description: "Comprehensive MEP system design and documentation"
        },
        {
            number: 5,
            title: "Final Review & Handover",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FMEP%2FHOW_IT_WORKS_icon%2FFinal_Review_and_Handover.png?alt=media&token=116e0d08-d1cf-4922-b522-08f3002cbf7a",
            description: "Quality check and project delivery"
        }
    ];


    return (
        <>
            <HowItWorks steps={steps} />
        </>
    );
};

export default HowItWorksMEP;
